import axios from "axios";
import type { AxiosResponse } from "axios";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";

export interface FindVehicleByStockNumberResponse {
    ErrorMessage: string | null;
    RedirectURL: string | null;
    Success: boolean;
}

export const findVehicleByStockNumber = async (
    url: string
): Promise<AxiosResponse<FindVehicleByStockNumberResponse>> => {
    const response = await axios.post(url);
    axiosOnSuccessEvent(response);
    return response;
};
